(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.arrayEditor
   * @description
   *
   */
  angular
    .module('utils.listEditor', [
      'ui.router'
    ]);
}());
